import { createAction, props } from '@ngrx/store'
import { TokeetAIChargeResponse } from './ai-charge.model'

export const LoadTokeetAICharges = createAction('[AI] Load TokeetAI Charges')
export const LoadTokeetAIChargesComplete = createAction(
  '[AI] Load TokeetAI Charges Complete',
  props<{ items: TokeetAIChargeResponse[] }>()
)
